import constants from '@common/constants';
import { useAtendeAuth } from '@common/hooks/useAtendeAuth';
import { useRedline } from '@libs/redline';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { removeCookie, getCookie } from '@libs/utils/helpers/getSafeCookies';

import { useAuthentication } from '@libs/acp/contexts/Authentication';

import '../styles.scss';
import PageLoader from '@common/components/PageLoader';

export default function PublicRoutes() {
  useAtendeAuth();
  const { search } = useLocation();
  const { createCorrelationId } = useRedline();

  const { isLoading } = useAuthentication();

  const searchParams = new URLSearchParams(search);

  useEffect(() => {
    createCorrelationId(constants.redline.RL_TRACK_CID);
  }, []);

  useEffect(() => {
    onStart();
  }, []);

  function onStart() {
    const isUtmMedium = searchParams.get('utm_medium');
    const hasSessionStarted = getCookie('rl_sscompleted');
    if (isUtmMedium === 'email' && hasSessionStarted) {
      removeCookie('rl_sscompleted');
    }
  }

  if (isLoading) return <PageLoader />;

  return <Outlet />;
}
